import paginationClasses from "@mui/material/Pagination/paginationClasses";
import paginationItemClasses from "@mui/material/PaginationItem/paginationItemClasses";
export const MuiPaginationTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                [`.${paginationClasses.ul}`]: {
                    columnGap: dt.inline.small,
                },
            },
            outlined: {
                [`.${paginationClasses.ul}`]: {
                    flexWrap: "nowrap",
                    columnGap: 0,
                    "& > li": {
                        borderTop: `1px solid ${dt.color.outline}`,
                        borderBottom: `1px solid ${dt.color.outline}`,
                        borderLeft: `1px solid ${dt.color.outline}`,
                        "&:first-of-type": {
                            borderTopLeftRadius: dt.borderRadius.small,
                            borderBottomLeftRadius: dt.borderRadius.small,
                            [`& > .${paginationItemClasses.root}, & > .${paginationItemClasses.root}::after`]: {
                                borderTopLeftRadius: dt.borderRadius.small,
                                borderBottomLeftRadius: dt.borderRadius.small,
                            },
                            [`& > .${paginationItemClasses.firstLast}`]: {
                                marginRight: 0,
                            },
                        },
                        "&:last-of-type": {
                            borderRight: `1px solid ${dt.color.outline}`,
                            borderTopRightRadius: dt.borderRadius.small,
                            borderBottomRightRadius: dt.borderRadius.small,
                            [`& > .${paginationItemClasses.root}, & > .${paginationItemClasses.root}::after`]: {
                                borderTopRightRadius: dt.borderRadius.small,
                                borderBottomRightRadius: dt.borderRadius.small,
                            },
                            [`& > .${paginationItemClasses.firstLast}`]: {
                                marginLeft: 0,
                            },
                        },
                    },
                },
                [`.${paginationItemClasses.root}`]: {
                    margin: 0,
                    borderRadius: 0,
                    borderWidth: 0,
                    "&.Mui-selected": {
                        borderWidth: 0,
                    },
                },
            },
        },
    };
};
